import { render } from "./footerHome.vue?vue&type=template&id=66a48936&scoped=true"
const script = {}

import "./footerHome.vue?vue&type=style&index=0&id=66a48936&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-66a48936"]])

export default __exports__